var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rhcn-button",class:{
  'rhcn-button--border': _vm.border,
  'rhcn-button--disabled': _vm.disabled,
  'rhcn-button--hover': _vm.hoverColor
},style:(_vm.buttonStyle),attrs:{"tabindex":_vm.disabled ? -1 : 0,"role":"button"},on:{"click":_vm.clickHandler}},[(_vm.icon)?_c('img',{staticClass:"rhcn-button__icon",attrs:{"src":_vm.icon,"alt":_vm.iconAlt}}):_vm._e(),_c('span',{staticClass:"rhcn-button__text"},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.text))]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }